import { API } from 'aws-amplify'

export const TeamAPI = {
    fetchTeamList: (id) => API.get('teams', `/list/staff/${id}`, {}),
    fetchTeamDetails: (team_id) => API.get('teams', `/get/div-entity/${team_id}`, {}),
    fetchTeamById: (team_id) => API.get('teams', `/get/id/${team_id}`, {})
}